export const plural = (number, words) => {
  return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
  "AchievementApp.Navbar.pageTitle": "Достижения",
  "LimitedAccountPanel.2step.href": "",
  "LimitedAccountPanel.email.href": "https://store.pixstorm.ru/user.php",
  "AuthorizationRequiredMessage.body.h3.2": "Достижения Pixel Storm",
  "AuthorizationRequiredMessage.login": "Войти",
  "Legal.Copyright": "Содержимое этого сайта предоставлено Gaijin Entertainment. Полная правовая информация доступна в",
  "Legal.Copyright.link": "Юридическом уведомлении"
}